export default {
    // 中
    zhCN: {
        five_day_engineer_response_rate_report: '5天工程师答复率报表',
        five_day_closure_rate_statistics: '5天关闭率统计',
        Number_of_cases_in: '案件数',
        Closed_cases_in: '已关闭',
        Number_of_closures_in_five_days_in: '5天关闭数',
    },
    // 英
    enUS: {
        five_day_engineer_response_rate_report: '5-Day Engineer Response Rate Report',
        five_day_closure_rate_statistics: '5-Day Closure Rate Statistics',
        Number_of_cases_in: 'Number of Cases in',
        Closed_cases_in: 'Closed Cases in',
        Number_of_closures_in_five_days_in: 'Number of Closures in 5 Days',
    },
    // 德
    deDE: {
        five_day_engineer_response_rate_report: 'Ingenieur-Antwortrate-Bericht für 5 Tage',
        five_day_closure_rate_statistics: 'Schließungsrate-Statistik für 5 Tage',
        Number_of_cases_in: 'Number of Cases in',
        Closed_cases_in: 'Closed Cases in',
        Number_of_closures_in_five_days_in: 'Number of Closures in 5 Days',
    },
    // 法
    frFR: {
        five_day_engineer_response_rate_report:
            'Rapport sur le taux de réponse des ingénieurs en 5 jours',
        five_day_closure_rate_statistics: 'Statistiques sur le taux de fermeture en 5 jours',
        Number_of_cases_in: 'Number of Cases in',
        Closed_cases_in: 'Closed Cases in',
        Number_of_closures_in_five_days_in: 'Number of Closures in 5 Days',
    },
    // 意大利
    itIT: {
        five_day_engineer_response_rate_report:
            'Rapporto sul tasso di risposta degli ingegneri in 5 giorni',
        five_day_closure_rate_statistics: 'Statistiche sul tasso di chiusura in 5 giorni',
        Number_of_cases_in: 'Number of Cases in',
        Closed_cases_in: 'Closed Cases in',
        Number_of_closures_in_five_days_in: 'Number of Closures in 5 Days',
    },
    // 荷兰
    nlNL: {
        five_day_engineer_response_rate_report:
            'Rapport over het reactiepercentage van ingenieurs gedurende 5 dagen',
        five_day_closure_rate_statistics: 'Statistieken over de sluitingsgraad in 5 dagen',
        Number_of_cases_in: 'Number of Cases in',
        Closed_cases_in: 'Closed Cases in',
        Number_of_closures_in_five_days_in: 'Number of Closures in 5 Days',
    },
    // 越南
    viVN: {
        five_day_engineer_response_rate_report: 'Báo cáo tỷ lệ phản hồi của kỹ sư trong 5 ngày',
        five_day_closure_rate_statistics: 'Thống kê tỷ lệ đóng cửa trong 5 ngày',
        Number_of_cases_in: 'Number of Cases in',
        Closed_cases_in: 'Closed Cases in',
        Number_of_closures_in_five_days_in: 'Number of Closures in 5 Days',
    },
    // 西班牙
    esES: {
        five_day_engineer_response_rate_report:
            'Informe sobre la tasa de respuesta de ingenieros en 5 días',
        five_day_closure_rate_statistics: 'Estadísticas de la tasa de cierre en 5 días',
        Number_of_cases_in: 'Number of Cases in',
        Closed_cases_in: 'Closed Cases in',
        Number_of_closures_in_five_days_in: 'Number of Closures in 5 Days',
    },
    // 葡萄牙
    ptBR: {
        five_day_engineer_response_rate_report:
            'Relatório de taxa de resposta de engenheiros em 5 dias',
        five_day_closure_rate_statistics: 'Estatísticas da taxa de fechamento em 5 dias',
        Number_of_cases_in: 'Number of Cases in',
        Closed_cases_in: 'Closed Cases in',
        Number_of_closures_in_five_days_in: 'Number of Closures in 5 Days',
    },
    // 波兰
    plPL: {
        five_day_engineer_response_rate_report:
            'Raport wskaźnika odpowiedzi inżynierów w ciągu 5 dni',
        five_day_closure_rate_statistics: 'Statystyki wskaźnika zamknięcia na przestrzeni 5 dni',
        Number_of_cases_in: 'Number of Cases in',
        Closed_cases_in: 'Closed Cases in',
        Number_of_closures_in_five_days_in: 'Number of Closures in 5 Days',
    },
    // 土耳其
    trTR: {
        five_day_engineer_response_rate_report: '5 Günlük Mühendis Yanıt Oranı Raporu',
        five_day_closure_rate_statistics: '5 Günlük Kapanış Oranı İstatistikleri',
        Number_of_cases_in: 'Number of Cases in',
        Closed_cases_in: 'Closed Cases in',
        Number_of_closures_in_five_days_in: 'Number of Closures in 5 Days',
    },
    // 捷克语
    csCZ: {
        five_day_engineer_response_rate_report: 'Statistika odpovědi technika za 5 dní',
        five_day_closure_rate_statistics: 'Statistika uzavřených případů za 5 dní',
        Number_of_cases_in: 'Počet případů v',
        Closed_cases_in: 'Uzavřené případy v',
        Number_of_closures_in_five_days_in: 'Počet uzavřených případů za 5 dní',
    },
    // 匈牙利语
    huHU: {
        five_day_engineer_response_rate_report: 'Kimutatás az 5 napos szerelői reagálási arányról',
        five_day_closure_rate_statistics: '5 napos esetlezárási aránystatisztikák',
        Number_of_cases_in: 'Esetek száma itt:',
        Closed_cases_in: 'Lezárt esetek itt:',
        Number_of_closures_in_five_days_in: '5 napon belüli lezárások',
    },
    // 俄罗斯
    ruRU: {
        five_day_engineer_response_rate_report: 'Отчет о скорости ответа инженера за 5 дней',
        five_day_closure_rate_statistics: 'Статистика закрытия за 5 дней',
        Number_of_cases_in: 'Количество дел в',
        Closed_cases_in: 'Закрытые дела в',
        Number_of_closures_in_five_days_in: 'Количество закрытий за 5 дней',
    },
    // 沙特阿拉伯
    arSA: {
        five_day_engineer_response_rate_report: 'تقرير معدل استجابة المهندس خلال 5 أيام',
        five_day_closure_rate_statistics: 'إحصائيات معدل الإغلاق خلال 5 أيام',
        Number_of_cases_in: 'عدد الحالات',
        Closed_cases_in: 'الحالات المغلقة',
        Number_of_closures_in_five_days_in: 'عدد الحالات المغلقة خلال 5 أيام',
    },
    // 保加利亚
    bgBG: {
        five_day_engineer_response_rate_report:
            'Доклад за процент отговори на инженер в рамките на 5 дни',
        five_day_closure_rate_statistics: 'Статистика за процент затваряне в рамките на 5 дни',
        Number_of_cases_in: 'Брой случаи',
        Closed_cases_in: 'Затворени случаи',
        Number_of_closures_in_five_days_in: 'Брой затворени случаи в рамките на 5 дни',
    },
    // 丹麦语
    daDK: {
        five_day_engineer_response_rate_report:
            'Rapport om ingeniørens svarprocent inden for 5 dage',
        five_day_closure_rate_statistics: 'Statistik over lukningsprocent inden for 5 dage',
        Number_of_cases_in: 'Antal sager',
        Closed_cases_in: 'Lukkede sager',
        Number_of_closures_in_five_days_in: 'Antal sager lukket inden for 5 dage',
    },
    // 芬兰语
    fiFI: {
        five_day_engineer_response_rate_report: '5 päivän insinöörivastausprosenttiraportti',
        five_day_closure_rate_statistics: '5 päivän sulkemisprosenttitilasto',
        Number_of_cases_in: 'Tapauksien määrä',
        Closed_cases_in: 'Suljetut tapaukset',
        Number_of_closures_in_five_days_in: '5 päivässä suljettujen tapausten määrä',
    },
    // 繁体中文台湾
    zhTW: {
        five_day_engineer_response_rate_report: '5天工程師答覆率報表',
        five_day_closure_rate_statistics: '5天關閉率統計',
        Number_of_cases_in: '案件數',
        Closed_cases_in: '已關閉',
        Number_of_closures_in_five_days_in: '5天關閉數',
    },
    // 克罗地亚
    hrHR: {
        five_day_engineer_response_rate_report:
            'Izvješće o postotku odgovora inženjera unutar 5 dana',
        five_day_closure_rate_statistics: 'Statistika postotka zatvaranja unutar 5 dana',
        Number_of_cases_in: 'Broj slučajeva',
        Closed_cases_in: 'Zatvoreni slučajevi',
        Number_of_closures_in_five_days_in: 'Broj slučajeva zatvorenih unutar 5 dana',
    },
    // 拉脱维亚
    lvLV: {
        five_day_engineer_response_rate_report: '5 dienu inženiera atbildes ātruma ziņojums',
        five_day_closure_rate_statistics: '5 dienu slēgšanas līmeņa statistika',
        Number_of_cases_in: 'Lieta skaits',
        Closed_cases_in: 'Slēgtās lietas',
        Number_of_closures_in_five_days_in: 'Lieta skaits, kas slēgtas 5 dienu laikā',
    },
    // 立陶宛
    ltLT: {
        five_day_engineer_response_rate_report: '5 dienų inžinieriaus atsakymo normos ataskaita',
        five_day_closure_rate_statistics: '5 dienų uždarymo normos statistika',
        Number_of_cases_in: 'Bylų skaičius',
        Closed_cases_in: 'Uždarytos bylos',
        Number_of_closures_in_five_days_in: 'Bylų, uždarytų per 5 dienas, skaičius',
    },
    // 罗马尼亚
    roRO: {
        five_day_engineer_response_rate_report:
            'Raport privind rata de răspuns a inginerului în 5 zile',
        five_day_closure_rate_statistics: 'Statistici privind rata de închidere în 5 zile',
        Number_of_cases_in: 'Numărul de cazuri',
        Closed_cases_in: 'Cazuri închise',
        Number_of_closures_in_five_days_in: 'Numărul de cazuri închise în 5 zile',
    },
    // 挪威博克马尔
    nbNO: {
        five_day_engineer_response_rate_report: 'Rapport om ingeniørrespons innen 5 dager',
        five_day_closure_rate_statistics: 'Statistikk over lukking innen 5 dager',
        Number_of_cases_in: 'Antall saker',
        Closed_cases_in: 'Lukkede saker',
        Number_of_closures_in_five_days_in: 'Antall saker lukket innen 5 dager',
    },
    // 葡萄牙语巴西
    ptBX: {
        five_day_engineer_response_rate_report:
            'Relatório de taxa de resposta do engenheiro em 5 dias',
        five_day_closure_rate_statistics: 'Estatísticas de taxa de fechamento em 5 dias',
        Number_of_cases_in: 'Número de casos',
        Closed_cases_in: 'Casos encerrados',
        Number_of_closures_in_five_days_in: 'Número de casos encerrados em 5 dias',
    },
    // 瑞典语
    svSE: {
        five_day_engineer_response_rate_report: 'Rapport över ingenjörs svarsfrekvens inom 5 dagar',
        five_day_closure_rate_statistics: 'Statistik över stängningsfrekvens inom 5 dagar',
        Number_of_cases_in: 'Antal ärenden',
        Closed_cases_in: 'Stängda ärenden',
        Number_of_closures_in_five_days_in: 'Antal ärenden stängda inom 5 dagar',
    },
    // 斯洛伐克
    skSK: {
        five_day_engineer_response_rate_report: 'Správa o miere odpovede inžiniera do 5 dní',
        five_day_closure_rate_statistics: 'Štatistika miery uzatvorenia do 5 dní',
        Number_of_cases_in: 'Počet prípadov',
        Closed_cases_in: 'Uzatvorené prípady',
        Number_of_closures_in_five_days_in: 'Počet prípadov uzatvorených do 5 dní',
    },
    // 斯洛文尼亚
    slSI: {
        five_day_engineer_response_rate_report: 'Poročilo o odstotku odziva inženirja v 5 dneh',
        five_day_closure_rate_statistics: 'Statistika odstotka zaprtih primerov v 5 dneh',
        Number_of_cases_in: 'Število primerov',
        Closed_cases_in: 'Zaprta primera',
        Number_of_closures_in_five_days_in: 'Število primerov zaprtih v 5 dneh',
    },
    // 泰语
    thTH: {
        five_day_engineer_response_rate_report: 'รายงานอัตราการตอบกลับของวิศวกรภายใน 5 วัน',
        five_day_closure_rate_statistics: 'สถิติอัตราการปิดเคสภายใน 5 วัน',
        Number_of_cases_in: 'จำนวนเคส',
        Closed_cases_in: 'เคสที่ปิดแล้ว',
        Number_of_closures_in_five_days_in: 'จำนวนเคสที่ปิดภายใน 5 วัน',
    },
    // 乌克兰语
    ukUA: {
        five_day_engineer_response_rate_report:
            'Звіт про частку відповідей інженера протягом 5 днів',
        five_day_closure_rate_statistics: 'Статистика частки закриття протягом 5 днів',
        Number_of_cases_in: 'Кількість випадків',
        Closed_cases_in: 'Закриті випадки',
        Number_of_closures_in_five_days_in: 'Кількість випадків, закритих протягом 5 днів',
    },
    // 希腊语
    elGR: {
        five_day_engineer_response_rate_report:
            'Αναφορά ποσοστού απόκρισης μηχανικού εντός 5 ημερών',
        five_day_closure_rate_statistics: 'Στατιστικά ποσοστού κλεισίματος εντός 5 ημερών',
        Number_of_cases_in: 'Αριθμός περιστατικών',
        Closed_cases_in: 'Κλειστά περιστατικά',
        Number_of_closures_in_five_days_in: 'Αριθμός περιστατικών που κλείστηκαν εντός 5 ημερών',
    },
    // 爱沙尼亚
    etEE: {
        five_day_engineer_response_rate_report: '5-päevase inseneri vastuse määra aruanne',
        five_day_closure_rate_statistics: '5-päevase sulgemismäära statistika',
        Number_of_cases_in: 'Juhtumite arv',
        Closed_cases_in: 'Suletud juhtumid',
        Number_of_closures_in_five_days_in: '5 päeva jooksul suletud juhtumite arv',
    },
    // 哈萨克
    kkKZ: {
        five_day_engineer_response_rate_report:
            '5 күн ішіндегі инженердің жауап беру пайызы туралы есеп',
        five_day_closure_rate_statistics: '5 күн ішіндегі жабу пайызы бойынша статистика',
        Number_of_cases_in: 'Істер саны',
        Closed_cases_in: 'Жабылған істер',
        Number_of_closures_in_five_days_in: '5 күн ішінде жабылған істер саны',
    },
    // 希伯来语
    heIL: {
        five_day_engineer_response_rate_report: 'דוח שיעור תגובת מהנדס תוך 5 ימים',
        five_day_closure_rate_statistics: 'סטטיסטיקות שיעור סגירה תוך 5 ימים',
        Number_of_cases_in: 'מספר מקרים',
        Closed_cases_in: 'מקרים סגורים',
        Number_of_closures_in_five_days_in: 'מספר מקרים שנסגרו תוך 5 ימים',
    },
};
